import { type PlanHighlight, BASE_PLAN_INCLUSIONS } from "./helpers";

/**
 * What's Included Content
 * Shows base plan inclusions + plan-specific highlights
 */
export default function WhatsIncludedContent({
  highlights,
}: {
  highlights?: PlanHighlight[];
}) {
  return (
    <ul className="space-y-3 text-sm text-evergreen">
      {/* Base inclusions that come with all plans */}
      {BASE_PLAN_INCLUSIONS.map((item, idx) => (
        <li key={`base-${idx}`} className="flex items-start gap-2">
          <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-evergreen" />
          <span className={item.emphasize ? "font-bold" : ""}>
            {item.name}
            {item.subtext && (
              <span className="font-normal italic opacity-80">
                {" "}
                {item.subtext}
              </span>
            )}
          </span>
        </li>
      ))}
      {/* Plan-specific highlights from API */}
      {highlights?.map((item, idx) => (
        <li key={`highlight-${idx}`} className="flex items-start gap-2">
          <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-evergreen" />
          <span className={item.emphasize ? "font-bold" : ""}>
            {item.title}
          </span>
        </li>
      ))}
    </ul>
  );
}
